const html = require("choo/html");
const Button = require("../elements/button.js");
const Icon = require("../elements/icon.js");

module.exports = function NextLevelMessage(state, emit) {
  if (
    state.sharingMode &&
    state.sharingMode.active &&
    state.sharingMode.phase === "intro"
  ) {
    const nextButton = Button({
      text: "NEXT",
      size: "medium",
      color: "pink",
      onClick: () => emit("sharing-mode-next"),
    });
    const cancelButton = Button({
      text: "CANCEL",
      onClick: () => emit("cancel-sharing-mode"),
    });
    return html`
      <div class="next-level-message start-sharing-journey-panel">
        <p>
          let's check that all of the pieces are in the right spot before we
          share your project
        </p>
        <div>${nextButton}</div>
        <div>${cancelButton}</div>
      </div>
    `;
  }
  if (!state.levelComplete) {
    return null;
  }
  const continuePlayingButton = Button({
    text: "CONTINUE PLAYING",
    onClick: () => emit("continue-playing"),
  });
  const resetLevelButton = Button({
    text: "RESET LEVEL",
    onClick: () => emit("reset-level"),
  });
  const nextLeveLButton = Button({
    text: "GO TO NEXT LEVEL",
    onClick: () => emit("go-to-next-level"),
  });
  const backToBrowserButton = Button({
    text: "BACK TO HOMEPAGE",
    onClick: () => emit("back-to-browser"),
  });

  const lastScene = state.project.scenes[state.project.scenes.length - 1];
  const hasNextLevel = state.currentScene !== lastScene;
  if (state.levelCompleteMinimized) {
    return "";
  }
  if (state.playingTutorial) {
    let levelCompleteText = false;
    if (state.currentTutorial.levelCompleteText) {
      levelCompleteText = html([state.currentTutorial.levelCompleteText]);
    }
    if (!hasNextLevel) {
      if (!levelCompleteText) {
        levelCompleteText = html` <p>
            Congratulations! You completed the last level!
          </p>
          <p>
            Now you can go back to the browser to try out different sample
            projects or start with a blank project.
          </p>`;
      }
      return html`
        <div class="next-level-message">
          ${levelCompleteText}
          <div>${backToBrowserButton}</div>
        </div>
      `;
    }
    if (!levelCompleteText) {
      levelCompleteText = html`
        <p></p>
        <p>Congratulations! You completed the level!</p>
        <p>
          You can go on to the next level or use the
          <i class="icon icon-undo"></i> REWIND button to go back and keep
          experimenting.
        </p>
      `;
    }
    return html`
      <div class="next-level-message">
        ${levelCompleteText} ${nextLeveLButton}
      </div>
    `;
  } else {
    if (!hasNextLevel) {
      return html`
        <div class="next-level-message">
          <p>Congratulations! You completed the last level!</p>
          <p>
            Press the <i class="icon icon-undo"></i> REWIND button to keep
            experimenting.
          </p>
          <div>
            <!-- add a share button here-->
          </div>
        </div>
      `;
    }
    return html`
      <div class="next-level-message">
        <p>Congratulations! You completed the level!</p>
        <p>
          You can press the <i class="icon icon-undo"></i> REWIND button to go
          back and keep experimenting,
        </p>
        <p>Or you can continue to the next level.</p>
        <div>${nextLeveLButton}</div>
      </div>
    `;
  }
};
